import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { BulkCreateMachineRequest, BulkCreateMachineResponse } from '../types/machine-setup-types';

export class CreateMachineBulkUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(request: BulkCreateMachineRequest): Promise<BulkCreateMachineResponse> {
    return this.repository.createMachineBulk(request);
  }
}
